<template>
  <b-row>
    <b-col cols="12">
      <RekomPraktikDetail />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import RekomPraktikDetail from "./TableRekomendasi_izin_praktik_detail.vue";

export default {
  components: {
    BRow,
    BCol,

    RekomPraktikDetail,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
